import { addError } from './abstract';
import AttributeCondition from './attribute';
import { action, computed } from '@ember/object';
import { FormType } from 'cio/utils/forms';

export default class FormEventAttributeCondition extends AttributeCondition {
  // same as event attribute for back-end processing compatibility (comparison logic is the same):
  type = 'event_attribute';

  trackedAttributes = ['value', 'formType'];

  operator = 'eq';
  _event = 'form_submit';
  // currently only used to compare "form_id" event data attribute:
  name = 'form_id';

  value = '';

  isForeignEventFilterAttribute = false;

  formType!: FormType;

  @computed('shouldValidate', 'value')
  get errors(): Record<string, string[]> {
    let errors = {};

    if (!this.shouldValidate) {
      return errors;
    }

    if (!this.value) {
      addError(errors, 'value', "can't be blank");
    }

    return errors;
  }

  @action
  duplicate() {
    let duplicate = FormEventAttributeCondition.create();
    this.copyAllAttributes(this, duplicate);
    return duplicate;
  }

  copyAllAttributes(source: FormEventAttributeCondition, target: FormEventAttributeCondition) {
    target.setProperties({
      _event: this.event,
      name: source.name,
      value: source.value,
      formType: source.formType,
      operator: source.operator,
    });
  }

  get disallowDateOperators() {
    return false;
  }
}
